module.exports = __webpack_public_path__ + "static/location-hero-84ad19d9d6fe6e1d83e10d91d0ea3c1e.svg";